import McAfeeHeader from '../../components/docomo/McAfeeHeader.js'
import dAccountbtn from '../../assets/docomo_btn.png'
import { 
    Card, 
    Col,
    Row,
    Grid,
    Body 
} from '@mcafee/pegasus'
import McAfeeFooter from '../../components/docomo/McAfeeFooter.js'
import { useLocation } from "react-router-dom";
import Error from '../../components/docomo/Error.js'


export default function LoginPage() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const errorCode = params.get("errorCode");
    const handleClick = (event) => {
        event.preventDefault();
        // Redirect to the dアカウント login page with the required parameters
        const url=`${process.env.REACT_APP_DOCOMO_URL}?client_id=${process.env.REACT_APP_DOCOMO_CLIENT_ID}&redirect_uri=${encodeURIComponent(process.env.REACT_APP_DOCOMO_REDIRECT_URL)}&scope=${encodeURIComponent(process.env.REACT_APP_DOCOMO_SCOPE)}&response_type=${process.env.REACT_APP_DOCOMO_PARAM_RESPONSE_TYPE}&authif=${process.env.REACT_APP_DOCOMO_PARAM_AUTHIF}&idauth=${process.env.REACT_APP_DOCOMO_PARAM_IDAUTH}&state=${process.env.REACT_APP_DOCOMO_PARAM_STATE}&nonce=${process.env.REACT_APP_DOCOMO_PARAM_NONCE}&prompt=${process.env.REACT_APP_DOCOMO_PARAM_PROMPT}`;
        
        window.location.href = url;
    };

  return (
    <>
   <title>パソコン向けウイルス対策とインターネット セキュリティ | マカフィー</title>
    <div>
    <header className="App-header">
      <McAfeeHeader />
      </header>
      <main>
        
        <section>
            <div className= "bg-primary corner-xl bg-size-auto" >      
                <Grid >
                    { errorCode ? (<Error code={errorCode} />): null }
                    <Row center="xs">
                        <Col>
                            <Body level="1">
                                <Card className="py-72" featured >
                                    <div className="flex align-items-center">
                                        <Grid>
                                            <Row center="xs">
                                                <Col>
                                                    <p className='docomo-LogInPage'> PCセキュリティ powered by McAfeeを利用するためにdアカウントでログインしてください。</p>
                                                </Col> </Row>
                                                <Row center="xs">
                                                    <Col>
                                                        <div className="py-72">
                                                        <button onClick={handleClick} style={{border:'none', background:'none', cursor: 'pointer'}} >
                                                        <img src={dAccountbtn} alt='Login with dAccount'/>
                                                        </button>
                                                        </div>
                                                </Col>
                                             </Row>
                                         </Grid>
                                    </div> 
                                </Card>
                            </Body>
                        </Col>
                    </Row>
                </Grid>
            </div>
        </section>

      </main>
      <br />
      <footer className="App-header pt-48">
        <McAfeeFooter />
      </footer>
    </div>
    </>
  );
}
